import { render, staticRenderFns } from "./checktask.vue?vue&type=template&id=3c04117f&scoped=true"
import script from "./checktask.ts?vue&type=script&lang=js&external"
export * from "./checktask.ts?vue&type=script&lang=js&external"
import style0 from "./checktask.vue?vue&type=style&index=0&id=3c04117f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04117f",
  null
  
)

export default component.exports